<template>
  <section class="entitlementsView">
    <h1 class="admin-header">Entitlements <span v-if="orgTier" class="badge">{{orgTier}} Tier</span></h1>
    <h3>Technology Insights</h3>
    <section class="panelRow">
      <utilization-panel
        :loading="loading"
        metricName="Endpoint"
        :utilization-count="endpointCount"
        :utilization-limit="endpointLicenseCount"
      />
      <utilization-panel
        :loading="loading"
        metricName="Meeting User"
        :utilization-count="meetingUserCount"
        :utilization-limit="meetingUserLicenseCount"
      />
      <utilization-panel
        :loading="loading"
        metricName="Voice User"
        :utilization-count="voiceUserCount"
        :utilization-limit="voiceUserLicenseCount"
      />
    </section>

    <h3 class="laterRow">Space Insights</h3>
    <section class="panelRow">
      <utilization-panel
        :loading="loading"
        metricName="Space"
        :utilization-count="spaceCount"
        :utilization-limit="spaceLicenseCount"
      />
      <utilization-panel
        :loading="loading"
        metricName="Non-Tech Space"
        :utilization-count="nonTechSpaceCount"
        :utilization-limit="nonTechSpaceLicenseCount"
      />
    </section>
  </section>
</template>

<script>
  import EntitlementService from '../../services/EntitlementsService.js';
  import UtilizationPanel from './UtilizationPanel.vue';
  import { mapGetters } from 'vuex'

  export default {
    async mounted() {
      await this.update()
    },
    watch: {
      orgContext: async function(val) {
        await this.update()
      }
    },
    data() {
      return {
        loading: true,
        metadata: undefined,
        orgTier: undefined,
        endpointCount: undefined,
        endpointLicenseCount: undefined,
        meetingUserCount: undefined,
        meetingUserLicenseCount: undefined,
        nonTechSpaceCount: undefined,
        nonTechSpaceLicenseCount: undefined,
        spaceCount: undefined,
        spaceLicenseCount: undefined,
        voiceUserCount: undefined,
        voiceUserLicenseCount: undefined,
      };
    },
    computed: {
      ...mapGetters('user', {
          orgContext: 'getOrgContext'
      })
    },
    components: {
      UtilizationPanel,
    },
    methods: {
      async update() {
        let response = await EntitlementService.getEntitlementUsage();
        if (response.status === 200) {
          let data  = response.data;
          this.endpointCount = data.endpointCountRequest.rows[0][0];
          this.endpointLicenseCount = data.endpointLimitRequest.rows[0][0];

          this.meetingUserCount = data.meetingUserCountRequest.rows[0][0];
          this.meetingUserLicenseCount = data.meetingUserLimitRequest.rows[0][0];

          this.nonTechSpaceCount = data.nonTechRoomCountRequest.rows[0][0];
          this.nonTechSpaceLicenseCount = data.nonTechRoomLimitRequest.rows[0][0];

          this.spaceCount = data.roomCountRequest.rows[0][0];
          this.spaceLicenseCount = data.roomLimitRequest.rows[0][0];

          this.voiceUserCount = data.audioUserCountRequest.rows[0][0];
          this.voiceUserLicenseCount = data.audioUserLimitRequest.rows[0][0];

          this.orgTier = data.orgDataRequest.rows[0][1];

          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped="true">
  .entitlementsView {
    padding: 15px;
    border-radius: var(--border-radius);
    box-shadow: 0px 3px 6px #00000029;

    h1 {
      font-size: 22px;
      font-weight: bold;
      .badge {
        color: white;
        background-color: #404E55;
        border-radius: 4px;
        font-size: 12px;
        font-style: italic;
        text-transform: capitalize;
      }
    }
    h3 {
      font-size: 14px;
      color: var(--default-color);
      &.laterRow {
        margin-top: 35px;
      }
    }
  }
  .panelRow {
    display: grid;
    grid-template-columns: repeat(3, 30%);
    column-gap: 15px;
    grid-template-rows: 275px;
  }
</style>
